import React, { useRef } from "react";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import camera from "../asserts/img/camera.svg";
import styled, { useTheme } from "styled-components";
import { useMobile } from "../utils/mobile";
import { Text } from "../UI";

const FileInput = styled("input")`
  display: none;
`;

const ExtentionInsert = ({
  extentions,
  onAdd,
  singleFile = false,
  isWeb = false,
}) => {
  const { t } = useTranslation("support_calls");

  const theme = useTheme();
  const inputRef = useRef(null);
  const isMobile = useMobile();
  const disabled = singleFile && extentions?.length === 1;

  const onImgClick = () => {
    inputRef.current.click();
  };

  return (
    <>
      <div
        style={{
          margin: "10px 0",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 10,
          alignItems: isMobile ? "flex-start" : "flex-start",
          flexWrap: "nowrap",
        }}>
        <Text.H3 color={theme.color.text}>{t("add_files")}</Text.H3>
        <FileInput
          ref={inputRef}
          type="file"
          id="input-file-upload"
          multiple={false}
          onChange={disabled ? () => {} : onAdd}
        />
        <div
          onClick={disabled ? () => {} : onImgClick}
          style={{
            border: `1.4px solid ${theme.color.mainBlue}`,
            backgroundColor: theme.color.white,
            color: theme.color.mainBlue,
            borderRadius: 20,
            padding: 5,
            fontSize: 14,
            fontWeight: 500,
            gap: 14,
            display: "flex",
            flexDirection: "row",
            height: 36,
            lineHeight: "26px",
          }}>
          <img
            src={camera}
            alt="add file"
            style={{ marginInlineStart: "8px" }}
          />
          <div
            style={{
              marginInlineEnd: "8px",
              overflow: "hidden",
              whiteSpace: "wrap",
              textOverflow: "ellipsis",
              textAlign: "start",
              lineHeight: "24px"
            }}>
            {isWeb ? t("add_file") : t("add_files_or_images")}
          </div>
        </div>
      </div>
    </>
  );
};

export default inject()(observer(ExtentionInsert));
